<template>
  <div>
    <h3 class="text-gray-700 text-3xl font-medium">Dashboard</h3>
  </div>
</template>

<script>


export default {
  name: "Dashboard",
  data(){
    return {

    }
  }
}
</script>

<style scoped>

</style>
